import ReactGA from 'react-ga4';

/**
 * Starts Google Analytics with its automatic pageview switched off.
 *
 * `send_page_view: false` is load-bearing, not tuning. Left at its default,
 * gtag fires a `page_view` at config time — before any React effect runs —
 * carrying `page_location` as the full `document.location.href`. On
 * `/auth/reset-password/<uidb36>/<key>` that publishes a live credential to
 * Analytics, and no amount of sanitising in `PageViewTracker` can undo a hit
 * that has already left the browser.
 *
 * `PageViewTracker` sends every pageview itself, with the path redacted, and
 * overrides `page_location` so the events that are not pageviews cannot carry
 * the raw URL either.
 *
 * Extracted from `App.tsx` so this is reachable from a test without importing
 * the whole application graph.
 */
export const initializeAnalytics = (measurementId: string | undefined) => {
  if (!measurementId) {
    return false;
  }

  ReactGA.initialize(measurementId, {gtagOptions: {send_page_view: false}});
  return true;
};
